module.exports = __webpack_public_path__ + "media/images/icons/material/upload-file-9811710030e543e4d953595f3d4cd28b.svg";